import { createHurdleOverride, loadApp, updateHurdleOverride } from "../../actions";

export const mapDispatchToProps = dispatch => ({
  createHurdleOverride: payload => createHurdleOverride(dispatch, payload),
  updateHurdleOverride: payload => updateHurdleOverride(dispatch, payload),
  loadApp: id => loadApp(dispatch, id),
});
